import { Payload } from '../commonMixed/Payload';

export class UpdateTerminalModeRequest extends Payload {
  constructor(private isSupportTerminal: boolean) {
    super(true);
  }
}
